import { Textinput, Textarea } from "shared";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import cn from "classnames";
import { TextareaProps } from "@yandex-int/hr-components/Textarea/bundle";
import { TextinputProps } from "@yandex-int/hr-components/Textinput/bundle";
import { IValidateError } from "../../lib";
import styles from "./dynamic-input.module.scss";

interface Props {
    containerClassName?: string;
    validate?: boolean;
    validateFunc?: (value: string) => IValidateError;
    triggerValidate?: number;
    id?: string
}

interface DynamicTextInputProps extends TextinputProps, Props {
    textareaEdge?: number;
    name: string;
    value: string;
    component?: ReactNode;
}

interface DynamicTextAreaProps extends TextareaProps, Props {
    textareaEdge?: number;
    name: string;
    value: string;
    component?: ReactNode;
}

export const DynamicInput: React.FC<DynamicTextInputProps | DynamicTextAreaProps> = ({
                                                                                         textareaEdge,
                                                                                         name,
                                                                                         id,
                                                                                         component,
                                                                                         containerClassName,
                                                                                         validate,
                                                                                         validateFunc,
                                                                                         triggerValidate,
                                                                                         ...props
                                                                                     }) => {
    const TEXTAREA_EDGE: number = 40 as const;
    const [value, setValue] = useState<string>();
    const [renderTextArea, setRenderTextArea] = useState(false);

    useEffect(() => {
        const isRenderTextArea = !!props.value && props.value.toString().length > (textareaEdge ? textareaEdge : TEXTAREA_EDGE);
        setRenderTextArea(isRenderTextArea);
        setValue(props.value as string | undefined);
    }, [props.value]);

    const focusAndPlaceCaretPosition = (caretPosition: number) => {
        setTimeout(() => {
            const inputContainer = document.getElementsByClassName(constructDynamicClassName(name))[0];
            if (inputContainer) {
                const textArea = inputContainer.getElementsByTagName("textarea")[0];
                const input = inputContainer.getElementsByTagName("input")[0];

                if (textArea) {
                    textArea.setSelectionRange(caretPosition, caretPosition)
                    textArea.focus();
                }
                if (input) {
                    input.setSelectionRange(caretPosition, caretPosition)
                    input.focus();
                }
            }
        })
    }


    const onChange = (e: any) => {
        const updatedValue = e.target.value;
        if (updatedValue !== value) {
            const caretPosition = e.target.selectionStart;
            const isRenderTextArea = !!updatedValue && updatedValue.toString().length > (textareaEdge ? textareaEdge : TEXTAREA_EDGE);
            setRenderTextArea(isRenderTextArea);
            setValue(updatedValue);
            props.onChange && props.onChange(e);
            focusAndPlaceCaretPosition(caretPosition);
        }
    }

    const constructDynamicClassName = (name: string) => {
        return `dynamic-${name}`;
    }

    const renderTextInput: React.FC<TextinputProps> = (props) => (
        <Textinput
            id={id}
            containerClassName={containerClassName}
            className={cn(props.className, constructDynamicClassName(name))}
            view={props.view}
            size={props.size}
            disabled={props.disabled}
            name={props.name}
            value={value}
            placeholder={props.placeholder}
            onChange={onChange}
            validate={validate}
            validateFunc={validateFunc}
            triggerValidate={triggerValidate}
        />
    )

    const renderTextarea: React.FC<TextareaProps> = (props) => (
        <Textarea
            id={id}
            className={cn(props.className, constructDynamicClassName(name))}
            disabled={props.disabled}
            name={props.name}
            value={value}
            onChange={onChange}
        />
    )

    return <div className={cn(props.disabled ? styles.disabledInputContainer : "", containerClassName)}>
        {component ?
            <div className={cn(props.className, styles.componentWrapper)}>{component}</div> :
            <>
                {renderTextArea && renderTextarea({ ...props } as TextareaProps)}
                {!renderTextArea && renderTextInput({ ...props } as TextinputProps)}
            </>
        }
    </div>;
};
